import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button'];

  connect() {
    this.setupBackButton();
  }

  setupBackButton() {
    const backButton = this.buttonTarget;
    if (backButton.tagName === 'BUTTON') return;

    const fallbackUrl = this.getBackButtonFallbackUrl(backButton);

    if (fallbackUrl) {
      backButton.setAttribute('href', fallbackUrl);
    } else {
      // TODO This else block is unreachable since fallbackUrl is always defined. Need to clean up and refactor the logic on the file.
      backButton.addEventListener('click', (event) => {
        if (window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      });
    }
  }

  getBackButtonFallbackUrl(backButton) {
    const parentUrl = backButton.dataset.parentUrl;

    if (parentUrl && parentUrl.trim() !== '') {
      return parentUrl;
    }

    return this.computeFallbackUrl(window.location.href);
  }

  computeFallbackUrl(currentUrl) {
    const urlObj = new URL(currentUrl);
    const pathname = urlObj.pathname;
    const pathSegments = pathname.split('/').filter(segment => segment.length > 0);

    if (pathSegments.length > 1) {
      const newPathname = '/' + pathSegments[0];
      return urlObj.origin + newPathname;
    }

    return urlObj.origin;
  }
}
